/**
 * Browser Fingerprinting - Erstellt eindeutigen Fingerprint ohne Cookies
 * Basiert auf verschiedenen Browser- und Geräteeigenschaften
 */

export const generateFingerprint = async () => {
  const components = [];

  // 1. Canvas Fingerprinting
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = 200;
    canvas.height = 50;
    
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillStyle = '#f60';
    ctx.fillRect(0, 0, 200, 50);
    ctx.fillStyle = '#069';
    ctx.fillText('Freundebuch 🎨', 2, 15);
    ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
    ctx.fillText('Fingerprint', 4, 17);
    
    const canvasData = canvas.toDataURL();
    components.push(canvasData);
  } catch (e) {
    components.push('canvas-error');
  }

  // 2. Screen Resolution
  components.push(`${screen.width}x${screen.height}x${screen.colorDepth}`);

  // 3. Timezone
  components.push(Intl.DateTimeFormat().resolvedOptions().timeZone);

  // 4. Language
  components.push(navigator.language);

  // 5. Platform
  components.push(navigator.platform);

  // 6. User Agent
  components.push(navigator.userAgent);

  // 7. Hardware Concurrency
  components.push(navigator.hardwareConcurrency || 'unknown');

  // 8. Device Memory (if available)
  components.push(navigator.deviceMemory || 'unknown');

  // 9. Touch Support
  components.push(navigator.maxTouchPoints || 0);

  // 10. Plugins (simplified)
  const plugins = Array.from(navigator.plugins || [])
    .map(p => p.name)
    .join(',');
  components.push(plugins || 'none');

  // Combine all components and hash
  const fingerprint = await hashString(components.join('|||'));
  return fingerprint;
};

// Simple hash function
const hashString = async (str) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
};

// Check if user already entered (LocalStorage + Backend)
export const checkAlreadyEntered = async () => {
  // 1. Check LocalStorage first (fast)
  const localCheck = localStorage.getItem('freundebuch_entered');
  if (localCheck) {
    return {
      alreadyEntered: true,
      date: localCheck,
      method: 'localStorage'
    };
  }

  // 2. Check Backend with fingerprint
  const fingerprint = await generateFingerprint();
  
  try {
    const response = await fetch('/api/fingerprint.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ fingerprint })
    });
    
    const result = await response.json();
    
    if (result.alreadyEntered) {
      return {
        alreadyEntered: true,
        date: result.date,
        method: 'fingerprint'
      };
    }
  } catch (error) {
    console.error('Fingerprint check failed:', error);
  }

  return { alreadyEntered: false };
};

// Mark as entered (LocalStorage + Backend)
export const markAsEntered = async () => {
  const now = new Date().toISOString();
  
  // 1. Save to LocalStorage
  localStorage.setItem('freundebuch_entered', now);
  
  // 2. Save to Backend
  const fingerprint = await generateFingerprint();
  
  try {
    await fetch('/api/fingerprint.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        fingerprint,
        action: 'mark_entered'
      })
    });
  } catch (error) {
    console.error('Failed to mark as entered:', error);
  }
};

export default {
  generateFingerprint,
  checkAlreadyEntered,
  markAsEntered
};
